import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'legal-dpa',
		path: '/policies/dpa',
		priority: 100, // to be matched before /policies/:slug
		component: loadable(async () => import(/* webpackChunkName: "pages/legal-dpa" */ './index'), {
			exportName: 'Dpa',
			fallback: Loading,
		}),
		frame: true,
		preventCookieWall: true,
		ssr: {
			enabled: true,
			seo: false, // page should not be indexable
			config: {
				disallowUserData: true,
				cache: {
					enabled: true,
					lifetimeInSeconds: 1 * 60 * 60, // 1 hour
				},
			},
		},
	},
];
